<script setup>
import {computed} from 'vue';
import {statusFolder} from "@/types.js";

const props = defineProps({
  light: {
    type: Boolean,
    required: false,
    default: false,
  },
  status: {
    type: String,
    required: true,
  },
});

const statusLabel = computed(() => {
  const statusObj = statusFolder.find(s => s.value === props.status);
  return statusObj ? statusObj.label : "Inconnu";
});

</script>

<template>
<span class="bg-green-100 inline-flex items-center text-xs font-medium me-2 px-2.5 py-1 rounded-full w-full max-w-max"
      :class="{'text-grey-600 ring-grey-300 ring-1 bg-grey-100': props.light, 'text-white': !props.light}">
    {{ statusLabel }}
    <slot></slot>
  </span>
</template>
